/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { services, services2 } from "../data/services";
import { socialMedial } from "../data/socialMedial";

const data = {
  header: require("../data/header.json"),
  footer: require("../data/footer.json"),
  site: require("../data/site.json"),
};

const socials = {};

export const TopNavigation = ({ boxheader }) => {
  return (
    <header>
      {/* start navigation */}
      <nav
        className={
          boxheader ||
          "navbar navbar-expand-lg navbar-light bg-transparent header-light fixed-top navbar-boxed header-reverse-scroll border-bottom border-color-black-transparent"
        }
      >
        <div className="container-fluid nav-header-container">
          <div className=" head col-auto col-sm-6 col-lg-2 mr-auto pl-lg-0">
            <a
              className="navbar-brand"
              href="/home"
              style={{ width: "max-content" }}
            >
              <img
                src={require("../media/images/logo.png").default}
                data-at2x={require("../media/images/logo.png").default}
                className="alt-logo"
                alt=""
                  style={{ maxHeight: 40, width: "auto", maxWidth: "100%" }}
              />
              <img
                src={require("../media/images/logo.png").default}
                data-at2x={require("../media/images/logo.png").default}
                className="default-logo"
                alt=""
                  style={{ maxHeight: 40, width: "auto", maxWidth: "100%" }}
              />
              <img
                src={require("../media/images/logo.png").default}
                data-at2x={require("../media/images/logo.png").default}
                className="mobile-logo"
                alt=""
                style={{ maxHeight: 40, width: "auto", maxWidth: "100%" }}
              />
            </a>
          </div>
          <div
            className="col-auto col-lg-8 menu-order"
            style={{
              paddingLeft: "60px",
            }}
          >
            <button
              className="navbar-toggler float-right"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-line" />
              <span className="navbar-toggler-line" />
              <span className="navbar-toggler-line" />
              <span className="navbar-toggler-line" />
            </button>
            <div
              className="collapse navbar-collapse justify-content-center"
              id="navbarNav"
            >
              <ul className="navbar-nav alt-font">
                {data.header.map((item, i) => {
                  if (item?.name === "Services") {
                    item.items = services2;
                  }

                  return (
                    <li
                      className={`nav-item  ${
                        window.location.pathname === item.link ? "active" : ""
                      } ${(item.items && "dropdown simple-dropdown") || ""}`}
                      key={"nav-" + i}
                    >
                      <a
                        href={item.link}
                        className="nav-link"
                        target={item.ext ? "_blank" : "_self"}
                        style={{ alignItems: "center", display: "inline-flex" }}
                      >
                        {item.icon && (
                          <>
                            <i
                              className={`${item.icon} icon-x-small align-middle text-fast-blue mr-2`}
                            ></i>
                            {"  "}
                          </>
                        )}

                        {item.name}
                      </a>

                      {item.items && (
                        <>
                          <i
                            className="fa fa-angle-down dropdown-toggle"
                            data-toggle="dropdown"
                            aria-hidden="true"
                          ></i>
                          <ul className="dropdown-menu" role="menu">
                            {item.items.map((sub, j) => {
                              return (
                                <li
                                  key={"hshsw-skks-" + i + j}
                                  className={`dropdown ${
                                    window.location.pathname.includes(sub.link)
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  <a href={sub.link}>
                                    {sub.name}
                                    <i className="fas fa-angle-right dropdown-toggle"></i>
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      )}
                    </li>
                  );
                })}
                  <li className="nav-item  text-white font-weight-bold">
                  <a href="https://24telemedcharity.org/" className="nav-link text-white" target="_blank">
                    <i className="fas fa-heart mr-2"></i> Support Us
                  </a>
                </li>
              </ul>
              
            </div>
          </div>
          <div className="col-auto col-lg-2 text-right pr-0 font-size-0">
            <div className="header-social-icon d-inline-block">
              {socialMedial.map((item, i) => (
                <a href={item.link} target="_blank">
                  <i className={item.icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>
      {/* end navigation */}
    </header>
  );
};

export const Footer = () => {
  const year = new Date().getFullYear();

  const contactLines = [
    { icon: "fas fa-map-marker-alt", label: "Abuja Office", text: "Plot 576 Independence Avenue , Central Business District, FCT Abuja" },
    { icon: "fas fa-phone-alt", text: "08065209446 · 08130790883 · 09024000024" },
    { icon: "fas fa-map-marker-alt", label: "Enugu Office", text: "East Side Hospital Independence Ave, Independence Layout, Enugu 400102, Enugu, Nigeria" },
    { icon: "fas fa-phone-alt", text: "+234 902 400 0024" },
    { icon: "fas fa-envelope", text: "info@24telemed.org" },
  ];

  const socialColors = {
    facebook: "#1877F2",
    instagram: "#E1306C",
  };

  return (
    <>
      <footer style={{ background: "#0a1a16", position: "relative", overflow: "hidden" }}>

        {/* Animated gradient top bar */}
        <div style={{
          height: 4,
          background: "linear-gradient(90deg, #37514B, #00b8b8, #4a6d65, #00b8b8, #37514B)",
          backgroundSize: "300% auto",
          animation: "borderFlow 4s linear infinite",
        }} />

        {/* Decorative blobs */}
        <div style={{ position: "absolute", width: 600, height: 600, background: "rgba(0,184,184,0.04)", borderRadius: "50%", filter: "blur(80px)", top: -200, right: -200, pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: 400, height: 400, background: "rgba(55,81,75,0.06)", borderRadius: "50%", filter: "blur(60px)", bottom: 0, left: -100, pointerEvents: "none" }} />
        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(rgba(0,184,184,0.04) 1px, transparent 1px)", backgroundSize: "40px 40px", pointerEvents: "none" }} />

        {/* Main footer body */}
        <div className="container" style={{ position: "relative", zIndex: 1, padding: "5rem 15px 3rem" }}>
          <div className="row g-5">

            {/* Column 1 — Brand */}
            <div className="col-12 col-lg-4 col-md-6">
              <a href="/" style={{ display: "inline-block", marginBottom: "1.5rem" }}>
                <img
                  src={require("../media/images/logo.png").default}
                  alt="24Telemed"
                  style={{ height: 50 }}
                />
              </a>
              <p style={{ color: "rgba(255,255,255,0.6)", lineHeight: 1.8, fontSize: "0.9rem", marginBottom: "1.75rem", maxWidth: 320 }}>
                Relentlessly breaking down healthcare disparities in rural Nigeria — connecting patients with qualified doctors 24/7 via phone and video.
              </p>

              {/* Social icons */}
              <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                {socialMedial.map((item, i) => (
                  <a
                    key={i}
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    title={item.name}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      background: "rgba(255,255,255,0.07)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "rgba(255,255,255,0.65)",
                      fontSize: "0.95rem",
                      textDecoration: "none",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = socialColors[item.className] || "#00b8b8";
                      e.currentTarget.style.color = "#fff";
                      e.currentTarget.style.transform = "translateY(-4px)";
                      e.currentTarget.style.borderColor = "transparent";
                      e.currentTarget.style.boxShadow = `0 8px 20px ${(socialColors[item.className] || "#00b8b8")}55`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(255,255,255,0.07)";
                      e.currentTarget.style.color = "rgba(255,255,255,0.65)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <i className={item.icon} />
                  </a>
                ))}
              </div>
            </div>

            {/* Column 2 — Company Links */}
            <div className="col-12 col-lg-2 col-md-3 col-sm-6">
              <h6 style={{ color: "#fff", fontWeight: 700, fontSize: "0.8rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: "1.5rem", position: "relative", paddingBottom: "0.75rem" }}>
                Company
                <span style={{ position: "absolute", bottom: 0, left: 0, width: 30, height: 2, background: "linear-gradient(90deg,#37514B,#00b8b8)", borderRadius: 1 }} />
              </h6>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {data?.footer.map((item, i) => (
                  <li key={i} style={{ marginBottom: "0.6rem" }}>
                    <a
                      href={item?.link}
                      target={item?.ext ? "_blank" : "_self"}
                      rel={item?.ext ? "noreferrer" : undefined}
                      style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.88rem", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6, transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = "#00b8b8"; e.currentTarget.style.transform = "translateX(6px)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; e.currentTarget.style.transform = "translateX(0)"; }}
                    >
                      <span style={{ width: 4, height: 4, borderRadius: "50%", background: "#00b8b8", flexShrink: 0, display: "inline-block" }} />
                      {item?.name}
                    </a>
                  </li>
                ))}
                <li style={{ marginBottom: "0.6rem" }}>
                  <a
                    href="https://24telemedcharity.org/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.88rem", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6, transition: "all 0.3s ease" }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = "#00b8b8"; e.currentTarget.style.transform = "translateX(6px)"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; e.currentTarget.style.transform = "translateX(0)"; }}
                  >
                    <span style={{ width: 4, height: 4, borderRadius: "50%", background: "#00b8b8", flexShrink: 0, display: "inline-block" }} />
                    <i className="fas fa-heart" style={{ fontSize: "0.7rem", color: "#ff6b6b" }} /> Support Us
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 — Services */}
            <div className="col-12 col-lg-3 col-md-3 col-sm-6">
              <h6 style={{ color: "#fff", fontWeight: 700, fontSize: "0.8rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: "1.5rem", position: "relative", paddingBottom: "0.75rem" }}>
                Services
                <span style={{ position: "absolute", bottom: 0, left: 0, width: 30, height: 2, background: "linear-gradient(90deg,#37514B,#00b8b8)", borderRadius: 1 }} />
              </h6>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {services2.map((item, i) => (
                  <li key={i} style={{ marginBottom: "0.6rem" }}>
                    <a
                      href={item?.link}
                      target={item?.link?.startsWith("http") ? "_blank" : "_self"}
                      rel={item?.link?.startsWith("http") ? "noreferrer" : undefined}
                      style={{ color: "rgba(255,255,255,0.55)", fontSize: "0.88rem", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6, transition: "all 0.3s ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = "#00b8b8"; e.currentTarget.style.transform = "translateX(6px)"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.55)"; e.currentTarget.style.transform = "translateX(0)"; }}
                    >
                      <span style={{ width: 4, height: 4, borderRadius: "50%", background: "#00b8b8", flexShrink: 0, display: "inline-block" }} />
                      {item?.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4 — Contact */}
            <div className="col-12 col-lg-3 col-md-6">
              <h6 style={{ color: "#fff", fontWeight: 700, fontSize: "0.8rem", letterSpacing: 2, textTransform: "uppercase", marginBottom: "1.5rem", position: "relative", paddingBottom: "0.75rem" }}>
                Contact
                <span style={{ position: "absolute", bottom: 0, left: 0, width: 30, height: 2, background: "linear-gradient(90deg,#37514B,#00b8b8)", borderRadius: 1 }} />
              </h6>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {contactLines.map((c, i) => (
                  <li key={i} style={{ display: "flex", gap: 12, marginBottom: "1.1rem" }}>
                    <div style={{ width: 32, height: 32, borderRadius: 8, background: "rgba(0,184,184,0.15)", border: "1px solid rgba(0,184,184,0.25)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#00b8b8", fontSize: "0.75rem" }}>
                      <i className={c.icon} />
                    </div>
                    <span style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.85rem", lineHeight: 1.6 }}>
                      {c.label && (
                        <span style={{ display: "block", color: "rgba(255,255,255,0.85)", fontWeight: 600, fontSize: "0.78rem", marginBottom: 2 }}>
                          {c.label}
                        </span>
                      )}
                      {c.text}
                    </span>
                  </li>
                ))}
              </ul>

              {/* Emergency call pill */}
              <a
                href="tel:08065209446"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: "0.5rem",
                  background: "linear-gradient(135deg,#37514B,#00b8b8)",
                  color: "#fff",
                  padding: "0.65rem 1.25rem",
                  borderRadius: 50,
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  textDecoration: "none",
                  boxShadow: "0 6px 20px rgba(0,184,184,0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,184,184,0.45)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,184,184,0.3)"; }}
              >
                <i className="fas fa-phone-alt" />
                Call a Doctor Now
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: "rgba(255,255,255,0.06)", margin: "0 15px" }} />

        {/* Bottom bar */}
        <div className="container" style={{ position: "relative", zIndex: 1, padding: "1.5rem 15px" }}>
          <div className="row align-items-center g-3">
            <div className="col-12 col-md-5 text-center text-md-left">
              <p style={{ margin: 0, color: "rgba(255,255,255,0.35)", fontSize: "0.82rem" }}>
                © {year} <strong style={{ color: "rgba(255,255,255,0.6)" }}>24Telemed</strong>. All rights reserved.
              </p>
            </div>
            <div className="col-12 col-md-7">
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexWrap: "wrap", gap: "0.25rem 1.5rem", justifyContent: "center" }}>
                {[
                  { label: "Privacy Policy", href: "/privacy-policy" },
                  { label: "Payment & Refund Policy", href: "/p/payment-refund-policy" },
                  { label: "Terms of Service", href: "/p/terms-of-services" },
                ].map((link, i) => (
                  <li key={i}>
                    <a
                      href={link.href}
                      style={{ color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", textDecoration: "none", transition: "color 0.3s ease" }}
                      onMouseEnter={(e) => { e.currentTarget.style.color = "#00b8b8"; }}
                      onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.35)"; }}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll-to-top */}
      <a
        className="scroll-top-arrow"
        href="/"
        onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
        style={{
          position: "fixed",
          bottom: "2rem",
          right: "2rem",
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: "linear-gradient(135deg,#37514B,#00b8b8)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: "0 6px 20px rgba(0,184,184,0.4)",
          zIndex: 999,
          textDecoration: "none",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px) scale(1.1)"; e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,184,184,0.6)"; }}
        onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0) scale(1)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,184,184,0.4)"; }}
      >
        <i className="feather icon-feather-arrow-up" style={{ fontSize: "1rem" }} />
      </a>
    </>
  );
};
